import IRequiredFloorNFCTagObject from "components/customerVenueWizard/interfaces/IRequiredFloorNFCTagObject";
import ICustomerVenue from "interfaces/ICustomerVenue";
import IOperator from "interfaces/IOperator";
import IUploadResponse from "interfaces/IUploadResponse";
import ExternalVenue from "models/externalVenue";

export interface ILocationStoreState {
  externalVenues: ExternalVenue[];
  customerVenueOperators?: IOperator[];
  requiredFloorNFCTagObject?: IRequiredFloorNFCTagObject;
  selectedVenue?: ICustomerVenue;
  uploadLocationResult?: IUploadResponse;
}

export const initialLocationStoreState: ILocationStoreState = {
  externalVenues: [],
};
